<template lang="pug">
  div.SearchListStratigraphic(:class="to === from ? ' disable' : null")
    .slider(ref='slider')
      .slider-value

    .SearchListStratigraphic_values

      .SearchListStratigraphic_value.SearchListStratigraphic_value_start
        p {{ startValue }}
        label {{$t('search.slider.unit')}}

      .SearchListStratigraphic_value.SearchListStratigraphic_value_end
        p {{ endValue }}
        label {{$t('search.slider.unit')}}
</template>

<script>

import { Component } from 'vue-instantsearch'
import noUiSlider from 'nouislider'
import { mapActions } from 'vuex'
// import SearchRangeInput from '@/components/SearchRangeInput'

export default {
  props: ['label', 'name'],
  mixins: [Component],
  // components: { SearchRangeInput },
  data () {
    return {
      startValue: 0,
      endValue: 10
    }
  },
  mounted () {
    noUiSlider.create(this.$refs.slider, this.options)
    this.$refs.slider.noUiSlider.on('update.one', this.changeRange)
    this.startValue = this.from
    this.endValue = this.to
  },
  computed: {
    from () {
      const items = this.searchStore.results
      return items.reduce((from, p) => p.stratigraphic_age_limits && (parseInt(p.stratigraphic_age_limits.from) < from || from === 0) ? parseInt(p.stratigraphic_age_limits.from) : from, 0)
    },
    to () {
      const items = this.searchStore.results
      return items.reduce((to, p) => p.stratigraphic_age_limits && (parseInt(p.stratigraphic_age_limits.to) > to || to === 1) ? parseInt(p.stratigraphic_age_limits.to) : to, 1)
    },
    options () {
      return {
        start: [ this.from, this.to ],
        step: 1,
        connect: true,
        range: {
          'min': this.from,
          'max': (this.to !== this.from) ? this.to : this.to + 1
        }
      }
    }
  },
  watch: {
    from (f) {
      this.updateSlider()
    }
  },
  methods: {
    ...mapActions([
      'setSearchOptions'
    ]),
    changeRange () {
      const values = this.$refs.slider.noUiSlider.get()
      this.startValue = parseInt(values[0])
      this.endValue = parseInt(values[1])
      this.setSearchOptions({ stratigraphic_age_limits: { from: values[0], to: values[1] } })
    },
    updateSlider () {
      this.$refs.slider.noUiSlider.updateOptions(this.options, true)
    }
  },
  beforeDestroy () {
    this.setSearchOptions(null)
  }
}

</script>

<style lang="stylus">

.SearchListStratigraphic

  &.disable
    display none

  margin-top 30px

  .slider

    margin-bottom 20px

  &_values

    display flex
    align-items flex-start
    justify-content space-between
    flex-direction row

  &_value

    color $beige
    margin-right auto
    margin-left 0px

    &_end

      text-align right
      margin-right 0px
      margin-left auto

    p

      font-size 30px
      font-weight 400
      letter-spacing 2px
      display block
      margin-bottom 5px

    label

      font-size 12px
      text-transform uppercase
      display block
      opacity 0.3

.cursor

  position relative

// noUi Style

.noUi-target,
.noUi-target *
  -webkit-touch-callout none
  -webkit-tap-highlight-color rgba(0, 0, 0, 0)
  -webkit-user-select none
  -ms-touch-action none
  touch-action none
  -ms-user-select none
  -moz-user-select none
  user-select none
  -moz-box-sizing border-box
  box-sizing border-box
.noUi-target
  position relative
  direction ltr
  background #FAFAFA
  border-radius 4px
  border 1px solid #D3D3D3
  box-shadow inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB
.noUi-base,
.noUi-connects
  width 100%
  height 100%
  position relative
  z-index 1
.noUi-connects
  overflow hidden
  z-index 0
  border-radius 3px
.noUi-connect,
.noUi-origin
  will-change transform
  position absolute
  z-index 1
  top 0
  left 0
  height 100%
  width 100%
  -ms-transform-origin 0 0
  -webkit-transform-origin 0 0
  transform-origin 0 0
html
  &:not([dir="rtl"])
    .noUi-horizontal
      .noUi-origin
        left auto
        right 0
      .noUi-handle
        right -17px
        left auto
.noUi-vertical
  width 18px
  .noUi-origin
    width 0
  .noUi-handle
    width 28px
    height 34px
    left -6px
    top -17px
    &:after
      top 17px
  .noUi-draggable
    cursor ns-resize
  .noUi-tooltip
    -webkit-transform translate(0, -50%)
    transform translate(0, -50%)
    top 50%
    right 120%
.noUi-horizontal
  height 18px
  .noUi-origin
    height 0
  .noUi-handle
    width 34px
    height 28px
    left -17px
    top -6px
  .noUi-tooltip
    -webkit-transform translate(-50%, 0)
    transform translate(-50%, 0)
    left 50%
    bottom 120%
.noUi-handle
  position absolute
  border 1px solid #D9D9D9
  border-radius 3px
  background #FFF
  cursor default
  box-shadow inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB
  &:after
    left 17px
.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin
  -webkit-transition transform 0.3s
  transition transform 0.3s
.noUi-state-drag
  *
    cursor inherit !important
.noUi-connect
  background #3FB8AF
.noUi-draggable
  cursor ew-resize
.noUi-active
  box-shadow inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB
.noUi-handle:before,
.noUi-handle:after
  content ""
  display block
  position absolute
  height 14px
  width 1px
  background #E8E7E6
  left 14px
  top 6px
.noUi-vertical .noUi-handle:before,
.noUi-vertical .noUi-handle:after
  width 14px
  height 1px
  left 6px
  top 14px
[disabled]
  .noUi-connect
    background #B8B8B8
[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle
  cursor not-allowed
.noUi-pips,
.noUi-pips *
  -moz-box-sizing border-box
  box-sizing border-box
.noUi-pips
  position absolute
  color #999
.noUi-value
  position absolute
  white-space nowrap
  text-align center
.noUi-value-sub
  color #ccc
  font-size 10px
.noUi-marker
  position absolute
  background #CCC
.noUi-marker-sub
  background #AAA
.noUi-marker-large
  background #AAA
.noUi-pips-horizontal
  padding 10px 0
  height 80px
  top 100%
  left 0
  width 100%
.noUi-value-horizontal
  -webkit-transform translate(-50%, 50%)
  transform translate(-50%, 50%)
.noUi-rtl
  .noUi-value-horizontal
    -webkit-transform translate(50%, 50%)
    transform translate(50%, 50%)
  .noUi-value-vertical
    -webkit-transform translate(0, 50%)
    transform translate(0, 50%)
.noUi-marker-horizontal
  &.noUi-marker
    margin-left -1px
    width 2px
    height 5px
  &.noUi-marker-sub
    height 10px
  &.noUi-marker-large
    height 15px
.noUi-pips-vertical
  padding 0 10px
  height 100%
  top 0
  left 100%
.noUi-value-vertical
  -webkit-transform translate(0, -50%)
  transform translate(0, -50%, 0)
  padding-left 25px
.noUi-marker-vertical
  &.noUi-marker
    width 5px
    height 2px
    margin-top -1px
  &.noUi-marker-sub
    width 10px
  &.noUi-marker-large
    width 15px
.noUi-tooltip
  display block
  position absolute
  border 1px solid #D9D9D9
  border-radius 3px
  background #fff
  color #000
  padding 5px
  text-align center
  white-space nowrap

.noUi-target

  background-color #5F5A50
  border 0px
  height 1px
  border-radius 0px
  box-shadow none

.noUi-connect

  background $beige

.noUi-handle

  width 18px!important
  height 18px!important
  box-shadow none
  border-radius 50%
  appearance none
  cursor pointer
  top -9px!important
  border 2px solid $beige
  background $grey-1
  box-sizing border-box
  transition all 0.6s $ease
  padding 0px

  &:hover

    transform scale(1.2)

  &:after, &:before

    content none

</style>
